import { IntakeBookingFlow } from "../components/IntakeBookingFlow";

export function Intake() {
  return <IntakeBookingFlow />;
}
